<template>
    <form @submit.prevent="handleSubmit(item)">
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.ehotelierTextId) }">
            <label for="_ehotelierTextId" class="control-label">Brandnamic eHotelier Text-Id</label>
            <input v-model="item.ehotelierTextId" type="text" placeholder="the Brandnamic eHotelier Text-Id" id="_ehotelierTextId" class="form-control"/>
            <span v-if="errors && errors.ehotelierTextId" class="help-block" id="_ehotelierTextId_helpBlock">{{ errors.ehotelierTextId }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.ehotelierTextId) }">
            <label for="_ehotelierTextId" class="control-label">Brandnamic eHotelier Multiclient</label>
            <input v-model="item.multiclient" type="text" placeholder="the Brandnamic eHotelier Multiclient, default: 'admin'" id="_multiclient" class="form-control"/>
            <span v-if="errors && errors.multiclient" class="help-block" id="_multiclient_helpBlock">{{ errors.multiclient }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.doImport) }">
            <label for="_doImport" class="control-label">Import data from eHotelier?</label>
            <input v-model="item.doImport" @change="doImportToggle" value="on" type="checkbox" placeholder="import data from eHotelier?" id="_doImport"
                   class="form-control"/>
            <span v-if="errors && errors.doImport" class="help-block"
                  id="_doImport_helpBlock">{{ errors.doImport }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.addressCountry) }">
            <label for="_addressCountry" class="control-label">Address Country</label>


            <select :disabled="!!item.doImport" v-model="item.addressCountry" type="text"
                    placeholder="The country. For example, USA. You can also provide the two-letter \[ISO 3166-1 alpha-2 country code\](http://en.wikipedia.org/wiki/ISO\_3166-1)." id="_addressCountry"
                    class="form-control importable">
                <option v-for="(value, key, index) in countries" :value="key">{{ value }}</option>

            </select>


            <!--<input v-model="item.addressCountry" type="text"
                   placeholder="The country. For example, USA. You can also provide the two-letter \[ISO 3166-1 alpha-2 country code\](http://en.wikipedia.org/wiki/ISO\_3166-1)."
                   id="_addressCountry" class="form-control importable"/>-->
            <span v-if="errors && errors.addressCountry" class="help-block" id="_addressCountry_helpBlock">{{ errors.addressCountry }}</span>
        </div>
        <div class="card bn-tabs">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li v-for="(value, key, index) in languages" class="nav-item" >
                    <a class="nav-link" v-bind:class="{ active: index===0, show: index===0 }" :id="'translation-tab-' + key" data-toggle="tab"
                       :href="'#translation-tab-content-' + key" role="tab" :aria-controls="index" aria-selected="false">{{
                        value }}</a>
                </li>
            </ul>
            <div class="tab-content" id="translationTabContent">
                <div v-for="(value, key) in item.translations" class="tab-pane fade"
                     v-bind:class="{ active: key==='de', show: key==='de' }" :id="'translation-tab-content-' + key"
                     role="tabpanel" :aria-labelledby="'translation-tab-' + key">
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.translations && errors.translations.name) }">
                        <label :for="'_translation_'+ key +'_name'" class="control-label">Name</label>
                        <input :readonly="!!item.doImport" v-model="item.translations[key].name" type="text"
                               placeholder="The name of the organization."
                               :id="'_translation_'+ key +'_name'" class="form-control importable"/>
                        <span v-if="errors && errors.translations && errors.name" class="help-block"
                              :id="'_translation_'+ key +'_name_helpBlock'">{{ errors.translations[key].name }}</span>
                    </div>
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.translations && errors.translations.legalName) }">
                        <label :for="'_translation_'+ key +'_legalName'" class="control-label">Legal Name</label>
                        <input :readonly="!!item.doImport" v-model="item.translations[key].legalName" type="text"
                               placeholder="The official name of the organization, e.g. the registered company name."
                               :id="'_translation_'+ key +'_legalName'" class="form-control importable"/>
                        <span v-if="errors && errors.translations && errors.legalName" class="help-block"
                              :id="'_translation_'+ key +'_legalName_helpBlock'">{{ errors.translations[key].legalName }}</span>
                    </div>

                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.translations && errors.translations.streetAddress) }">
                        <label :for="'_translation_'+ key +'_streetAddress'" class="control-label">Street Address</label>
                        <input :readonly="!!item.doImport" v-model="item.translations[key].streetAddress" type="text"
                               placeholder="The street address. For example, 1600 Amphitheatre Pkwy."
                               :id="'_translation_'+ key +'_streetAddress'" class="form-control importable"/>
                        <span v-if="errors && errors.translations && errors.streetAddress" class="help-block"
                              :id="'_translation_'+ key +'_streetAddress_helpBlock'">{{ errors.translations[key].streetAddress }}</span>
                    </div>

                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.translations && errors.translations.addressLocality) }">
                        <label :for="'_translation_'+ key +'_addressLocality'" class="control-label">Address Locality</label>
                        <input :readonly="!!item.doImport" v-model="item.translations[key].addressLocality" type="text"
                               placeholder="The locality. For example, Mountain View."
                               :id="'_translation_'+ key +'_addressLocality'" class="form-control importable"/>
                        <span v-if="errors && errors.translations && errors.addressLocality" class="help-block"
                              :id="'_translation_'+ key +'_addressLocality_helpBlock'">{{ errors.translations[key].addressLocality }}</span>
                    </div>




                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.chamberOfCommerce), 'countryhidden': ['IT','CH'].indexOf(item.addressCountry)==-1 }">
                        <label :for="'_translation_'+ key +'_chamberOfCommerce'" class="control-label">Chamber Of Commerce</label>
                        <input :readonly="!!item.doImport" v-model="item.translations[key].chamberOfCommerce" type="text"
                               placeholder="chamber of commerce (Italy, Switzerland)" id="_chamberOfCommerce"
                               class="form-control importable"/>
                        <span v-if="errors && errors.chamberOfCommerce" class="help-block"
                              :id="'_translation_'+ key +'_chamberOfCommerce_helpBlock'">{{ errors.chamberOfCommerce }}</span>
                    </div>
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.commercialRegister), 'countryhidden': ['DE'].indexOf(item.addressCountry)==-1 }">
                        <label :for="'_translation_'+ key +'_commercialRegister'" class="control-label">Commercial Register</label>
                        <input :readonly="!!item.doImport" v-model="item.translations[key].commercialRegister" type="text" placeholder="commercial register (Germany)"
                               :id="'_translation_'+ key +'_commercialRegister'" class="form-control importable"/>
                        <span v-if="errors && errors.commercialRegister" class="help-block"
                              :id="'_translation_'+ key +'_commercialRegister_helpBlock'">{{ errors.commercialRegister }}</span>
                    </div>
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.associationRegister), 'countryhidden': ['DE'].indexOf(item.addressCountry)==-1 }">
                        <label :for="'_translation_'+ key +'_associationRegister'" class="control-label">Association Register</label>
                        <input :readonly="!!item.doImport" v-model="item.translations[key].associationRegister" type="text"
                               placeholder="association register (Germany)" id="_associationRegister"
                               class="form-control importable"/>
                        <span v-if="errors && errors.associationRegister" class="help-block"
                              :id="'_translation_'+ key +'_associationRegister_helpBlock'">{{ errors.associationRegister }}</span>
                    </div>
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.partnershipRegister), 'countryhidden': ['DE'].indexOf(item.addressCountry)==-1 }">
                        <label :for="'_translation_'+ key +'_partnershipRegister'" class="control-label">Partnership Register</label>
                        <input :readonly="!!item.doImport" v-model="item.translations[key].partnershipRegister" type="text"
                               placeholder="partnership register (Germany)" id="_partnershipRegister"
                               class="form-control importable"/>
                        <span v-if="errors && errors.partnershipRegister" class="help-block"
                              :id="'_translation_'+ key +'_partnershipRegister_helpBlock'">{{ errors.partnershipRegister }}</span>
                    </div>
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.cooperativesRegister), 'countryhidden': ['DE'].indexOf(item.addressCountry)==-1 }">
                        <label :for="'_translation_'+ key +'_cooperativesRegister'" class="control-label">Cooperatives Register</label>
                        <input :readonly="!!item.doImport" v-model="item.translations[key].cooperativesRegister" type="text"
                               placeholder="cooperatives register (Germany)" id="_cooperativesRegister"
                               class="form-control importable"/>
                        <span v-if="errors && errors.cooperativesRegister" class="help-block"
                              :id="'_translation_'+ key +'_cooperativesRegister_helpBlock'">{{ errors.cooperativesRegister }}</span>
                    </div>
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.commercialCourt), 'countryhidden': ['AT'].indexOf(item.addressCountry)==-1 }">
                        <label :for="'_translation_'+ key +'_commercialCourt'" class="control-label">Commercial Court</label>
                        <input :readonly="!!item.doImport" v-model="item.translations[key].commercialCourt" type="text" placeholder="commercial court (Austria)"
                               :id="'_translation_'+ key +'_commercialCourt'" class="form-control importable"/>
                        <span v-if="errors && errors.commercialCourt" class="help-block"
                              :id="'_translation_'+ key +'_commercialCourt_helpBlock'">{{ errors.commercialCourt }}</span>
                    </div>
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.regulatoryAuthority), 'countryhidden': ['DE','CH','AT'].indexOf(item.addressCountry)==-1 }">
                        <label :for="'_translation_'+ key +'_regulatoryAuthority'" class="control-label">Regulatory Authority</label>
                        <input :readonly="!!item.doImport" v-model="item.translations[key].regulatoryAuthority" type="text"
                               placeholder="regulatory authority (Germany, Switzerland, Austria)"
                               :id="'_translation_'+ key +'_regulatoryAuthority'" class="form-control importable"/>
                        <span v-if="errors && errors.regulatoryAuthority" class="help-block"
                              :id="'_translation_'+ key +'_regulatoryAuthority_helpBlock'">{{ errors.regulatoryAuthority }}</span>
                    </div>
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.description) }">
                        <label :for="'_translation_'+ key +'_description'" class="control-label">Description</label>
                        <vue-editor :id="'_translation_'+ key +'_description'" :disabled="!!item.doImport" class="form-control importable" style="float:left; height:auto" v-model="item.translations[key].description" :editorToolbar="descriptionToolbar" :editorOptions="descriptionOptions"></vue-editor>
                        <span v-if="errors && errors.description" class="help-block" id="_description_helpBlock">{{ errors.description }}</span>
                    </div>
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.additionalImageSources) }">
                        <label :for="'_translation_'+ key +'_additionalImageSources'" class="control-label">Additional Image Sources</label>
                        <vue-editor :id="'_translation_'+ key +'_additionalImageSources'" :disabled="!!item.doImport" class="form-control importable" style="float:left; height:auto" v-model="item.translations[key].additionalImageSources" :editorToolbar="additionalImageSourcesToolbar" :editorOptions="additionalImageSourcesOptions"></vue-editor>
                        <span v-if="errors && errors.additionalImageSources" class="help-block" id="_additionalImageSources_helpBlock">{{ errors.additionalImageSources }}</span>
                    </div>
                    <div :class="{ 'form-group': true, 'has-error': (errors && errors.locale) }">
                        <input vmodel="item.translations[key].locale" type="hidden"
                               :id="'_translation_'+ key +'_locale'" class="form-control importable"/>
                        <input vmodel="item.translations[key].id" type="hidden" :id="'_translation_'+ key +'_id'"
                               class="form-control importable"/>
                        <span v-if="errors && errors.locale" class="help-block"
                              :id="'_translation_'+ key +'_locale_helpBlock'">{{ errors.locale }}</span>
                    </div>
                </div>
            </div>

        </div>

        <div :class="{ 'form-group': true, 'has-error': (errors && errors.email) }">
            <label for="_email" class="control-label">Email</label>
            <input :readonly="!!item.doImport" v-model="item.email" type="email" placeholder="email address" id="_email" class="form-control importable"/>
            <span v-if="errors && errors.email" class="help-block" id="_email_helpBlock">{{ errors.email }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.emailPec) }">
            <label for="_emailPec" class="control-label">PEC Email</label>
            <input :readonly="!!item.doImport" v-model="item.emailPec" type="email" placeholder="pec email address" id="_emailPec" class="form-control importable"/>
            <span v-if="errors && errors.emailPec" class="help-block" id="_emailPec_helpBlock">{{ errors.emailPec }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.url) }">
            <label for="_url" class="control-label">URL</label>
            <input :readonly="!!item.doImport" v-model="item.url" type="url" placeholder="url address" id="_url" class="form-control importable" />
            <span v-if="errors && errors.url" class="help-block" id="_url_helpBlock">{{ errors.url }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.telephone) }">
            <label for="_telephone" class="control-label">Telephone</label>
            <input :readonly="!!item.doImport" v-model="item.telephone" type="text" placeholder="the telephone number" id="_telephone"
                   class="form-control importable"/>
            <span v-if="errors && errors.telephone" class="help-block"
                  id="_telephone_helpBlock">{{ errors.telephone }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.faxNumber) }">
            <label for="_faxNumber" class="control-label">Fax Number</label>
            <input :readonly="!!item.doImport" v-model="item.faxNumber" type="text" placeholder="the fax number" id="_faxNumber"
                   class="form-control importable"/>
            <span v-if="errors && errors.faxNumber" class="help-block"
                  id="_faxNumber_helpBlock">{{ errors.faxNumber }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.logo) }">
            <label for="_logo" class="control-label">Logo</label>
            <div style="width:300px; float:left;">
                {{ api_url+'uploads/organization/'+item.logo}}
            <picture-input :display="!!item.doImport"
                    style="float:left;"
                    ref="pictureInput"
                    @change="onLogoChange"
                    width="300"
                    height="300"
                    margin="16"
                    :crop="false"
                    :zIndex="2"
                    id="_logo"
                    name="_logo"
                    accept="image/jpeg,image/png,image/gif"
                    size="10"
                    buttonClass="btn"
                    :prefill="item.logo ? (item.logo.substring(0,4)==='http' ? item.logo : api_url+'uploads/organization/'+item.logo) : ''"
                    :customStrings="{
        upload: '<h1>Bummer!</h1>',
        drag: 'an associated logo'
      }">
            </picture-input>

            </div><div style="clear:both;"></div>
            <span v-if="errors && errors.logo" class="help-block" id="_logo_helpBlock">{{ errors.logo }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.rea), 'countryhidden': ['IT'].indexOf(item.addressCountry)==-1 }">
            <label for="_rea" class="control-label">REA</label>
            <input :readonly="!!item.doImport" v-model="item.rea" type="text" placeholder="REA (Italy)" id="_rea" class="form-control importable"/>
            <span v-if="errors && errors.rea" class="help-block" id="_rea_helpBlock">{{ errors.rea }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.uid), 'countryhidden': ['CH'].indexOf(item.addressCountry)==-1}">
            <label for="_uid" class="control-label">UID</label>
            <input :readonly="!!item.doImport" v-model="item.uid" type="text" placeholder="UID (Switzerland)" id="_uid" class="form-control importable"/>
            <span v-if="errors && errors.uid" class="help-block" id="_uid_helpBlock">{{ errors.uid }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.chamberOfCommerceNumber), 'countryhidden': ['IT','CH'].indexOf(item.addressCountry)==-1 }">
            <label for="_chamberOfCommerceNumber" class="control-label">Chamber Of Commerce Number</label>
            <input :readonly="!!item.doImport" v-model="item.chamberOfCommerceNumber" type="text"
                   placeholder="chamber of commerce number (Italy, Switzerland)" id="_chamberOfCommerceNumber"
                   class="form-control importable"/>
            <span v-if="errors && errors.chamberOfCommerceNumber" class="help-block"
                  id="_chamberOfCommerceNumber_helpBlock">{{ errors.chamberOfCommerceNumber }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.commercialRegisterNumber), 'countryhidden': ['DE'].indexOf(item.addressCountry)==-1 }">
            <label for="_commercialRegisterNumber" class="control-label">Commercial Register Number</label>
            <input :readonly="!!item.doImport" v-model="item.commercialRegisterNumber" type="text"
                   placeholder="commercial register number (Germany)" id="_commercialRegisterNumber"
                   class="form-control importable"/>
            <span v-if="errors && errors.commercialRegisterNumber" class="help-block"
                  id="_commercialRegisterNumber_helpBlock">{{ errors.commercialRegisterNumber }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.associationRegisterNumber), 'countryhidden': ['DE'].indexOf(item.addressCountry)==-1 }">
            <label for="_associationRegisterNumber" class="control-label">Association Register Number</label>
            <input :readonly="!!item.doImport" v-model="item.associationRegisterNumber" type="text"
                   placeholder="association register number (Germany)" id="_associationRegisterNumber"
                   class="form-control importable"/>
            <span v-if="errors && errors.associationRegisterNumber" class="help-block"
                  id="_associationRegisterNumber_helpBlock">{{ errors.associationRegisterNumber }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.partnershipsRegisterNumber), 'countryhidden': ['DE'].indexOf(item.addressCountry)==-1 }">
            <label for="_partnershipsRegisterNumber" class="control-label">Partnerships Register Number</label>
            <input :readonly="!!item.doImport" v-model="item.partnershipsRegisterNumber" type="text"
                   placeholder="partnerships register number (Germany)" id="_partnershipsRegisterNumber"
                   class="form-control importable"/>
            <span v-if="errors && errors.partnershipsRegisterNumber" class="help-block"
                  id="_partnershipsRegisterNumber_helpBlock">{{ errors.partnershipsRegisterNumber }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.cooperativesRegisterNumber), 'countryhidden': ['DE'].indexOf(item.addressCountry)==-1 }">
            <label for="_cooperativesRegisterNumber" class="control-label">Cooperatives Register Number</label>
            <input :readonly="!!item.doImport" v-model="item.cooperativesRegisterNumber" type="text"
                   placeholder="cooperatives register number (Germany)" id="_cooperativesRegisterNumber"
                   class="form-control importable"/>
            <span v-if="errors && errors.cooperativesRegisterNumber" class="help-block"
                  id="_cooperativesRegisterNumber_helpBlock">{{ errors.cooperativesRegisterNumber }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.commercialCourtNumber), 'countryhidden': ['AT'].indexOf(item.addressCountry)==-1 }">
            <label for="_commercialCourtNumber" class="control-label">Commercial Court Number</label>
            <input :readonly="!!item.doImport" v-model="item.commercialCourtNumber" type="text" placeholder="commercial court number (Germany)"
                   id="_commercialCourtNumber" class="form-control importable"/>
            <span v-if="errors && errors.commercialCourtNumber" class="help-block"
                  id="_commercialCourtNumber_helpBlock">{{ errors.commercialCourtNumber }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.legalRepresentative) }">
            <label for="_legalRepresentative" class="control-label">Legal Representative</label>
            <input :readonly="!!item.doImport" v-model="item.legalRepresentative" type="text" placeholder="legal representative (Austria)"
                   id="_legalRepresentative" class="form-control importable"/>
            <span v-if="errors && errors.legalRepresentative" class="help-block" id="_legalRepresentative_helpBlock">{{ errors.legalRepresentative }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.administrator) }">
            <label for="_administrator" class="control-label">Administrator</label>
            <input :readonly="!!item.doImport" v-model="item.administrator" type="text" placeholder="the administrator name" id="_administrator"
                   class="form-control importable"/>
            <span v-if="errors && errors.administrator" class="help-block" id="_administrator_helpBlock">{{ errors.administrator }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.management) }">
            <label for="_management" class="control-label">Management</label>
            <input :readonly="!!item.doImport" v-model="item.management" type="text" placeholder="the management" id="_management"
                   class="form-control importable"/>
            <span v-if="errors && errors.management" class="help-block" id="_management_helpBlock">{{ errors.management }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.taxID) }">
            <label for="_taxID" class="control-label">Tax ID</label>
            <input :readonly="!!item.doImport" v-model="item.taxID" type="text"
                   placeholder="The Tax / Fiscal ID of the organization or person, e.g. the TIN in the US or the CIF/NIF in Spain."
                   id="_taxID" class="form-control importable"/>
            <span v-if="errors && errors.taxID" class="help-block" id="_taxID_helpBlock">{{ errors.taxID }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.vatID) }">
            <label for="_vatID" class="control-label">VAT ID</label>
            <input :readonly="!!item.doImport" v-model="item.vatID" type="text"
                   placeholder="The Value-added Tax ID of the organization or person."
                   id="_vatID" class="form-control importable"/>
            <span v-if="errors && errors.vatID" class="help-block" id="_vatID_helpBlock">{{ errors.vatID }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.cir) }">
          <label for="_cir" class="control-label">CIR</label>
          <input :readonly="!!item.doImport" v-model="item.cir" type="text"
                 placeholder="Codice Identificativo Regionale (Italy)"
                 id="_cir" class="form-control importable"/>
          <span v-if="errors && errors.cir" class="help-block" id="_cir_helpBlock">{{ errors.cir }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.cin) }">
          <label for="_cin" class="control-label">CIN</label>
          <input :readonly="!!item.doImport" v-model="item.cin" type="text"
                 placeholder="Codice Identificativo Nazionale (Italy)"
                 id="_cin" class="form-control importable"/>
          <span v-if="errors && errors.cin" class="help-block" id="_cin_helpBlock">{{ errors.cin }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.shareHolder) }">
            <label for="_shareHolder" class="control-label">Share Holder</label>
            <input :readonly="!!item.doImport" v-model="item.shareHolder" type="text" placeholder="the share holder" id="_shareHolder"
                   class="form-control importable"/>
            <span v-if="errors && errors.shareHolder" class="help-block" id="_shareHolder_helpBlock">{{ errors.shareHolder }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.shareCapital) }">
            <label for="_shareCapital" class="control-label">Share Capital</label>
            <input :readonly="!!item.doImport" v-model="item.shareCapital" type="text" placeholder="the share capital" id="_shareCapital"
                   class="form-control importable"/>
            <span v-if="errors && errors.shareCapital" class="help-block" id="_shareCapital_helpBlock">{{ errors.shareCapital }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.editorial) }">
            <label for="_editorial" class="control-label">Editorial</label>
            <input :readonly="!!item.doImport" v-model="item.editorial" type="text" placeholder="editorial" id="_editorial" class="form-control importable"/>
            <span v-if="errors && errors.editorial" class="help-block"
                  id="_editorial_helpBlock">{{ errors.editorial }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.dataProtectionSupervisorTitle) }">
            <label for="_dataProtectionSupervisorTitle" class="control-label">Data Protection Supervisor Title</label>
            <input :readonly="!!item.doImport" v-model="item.dataProtectionSupervisorTitle" type="text"
                   placeholder="the title of the data protection supervisor" id="_dataProtectionSupervisorTitle"
                   class="form-control importable"/>
            <span v-if="errors && errors.dataProtectionSupervisorTitle" class="help-block"
                  id="_dataProtectionSupervisorTitle_helpBlock">{{ errors.dataProtectionSupervisorTitle }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.dataProtectionSupervisor) }">
            <label for="_dataProtectionSupervisor" class="control-label">Data Protection Supervisor</label>
            <input :readonly="!!item.doImport" v-model="item.dataProtectionSupervisor" type="text"
                   placeholder="the name of the data protection supervisor" id="_dataProtectionSupervisor"
                   class="form-control importable"/>
            <span v-if="errors && errors.dataProtectionSupervisor" class="help-block"
                  id="_dataProtectionSupervisor_helpBlock">{{ errors.dataProtectionSupervisor }}</span>
        </div>

        <div :class="{ 'form-group': true, 'has-error': (errors && errors.addressRegion) }">
            <label for="_addressRegion" class="control-label">Address Region</label>
            <input :readonly="!!item.doImport" v-model="item.addressRegion" type="text" placeholder="The region. For example, CA."
                   id="_addressRegion" class="form-control importable"/>
            <span v-if="errors && errors.addressRegion" class="help-block" id="_addressRegion_helpBlock">{{ errors.addressRegion }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.postOfficeBoxNumber) }">
            <label for="_postOfficeBoxNumber" class="control-label">Post Office Box Number</label>
            <input :readonly="!!item.doImport" v-model="item.postOfficeBoxNumber" type="text"
                   placeholder="the post office box number for PO box addresses" id="_postOfficeBoxNumber"
                   class="form-control importable"/>
            <span v-if="errors && errors.postOfficeBoxNumber" class="help-block" id="_postOfficeBoxNumber_helpBlock">{{ errors.postOfficeBoxNumber }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.postalCode) }">
            <label for="_postalCode" class="control-label">Postal Code</label>
            <input :readonly="!!item.doImport" v-model="item.postalCode" type="text" placeholder="The postal code. For example, 94043."
                   id="_postalCode" class="form-control importable"/>
            <span v-if="errors && errors.postalCode" class="help-block" id="_postalCode_helpBlock">{{ errors.postalCode }}</span>
        </div>


        <button type="submit" class="btn btn-primary">Submit</button>

    </form>

</template>
<style>
    .countryhidden{
        display: none;
    }
</style>

<script>
    import {API_LANGUAGES} from '../../config/languages';
    import { API_HOST, API_PATH } from '../../config/_entrypoint';
    import PictureInput from 'vue-picture-input';
    import { VueEditor } from 'vue2-editor';


    const API_URL = API_HOST+API_PATH;

    const COUNTRIES = {
        "AT": "Austria",
        "DE": "Germany",
        "IT": "Italy",
        "CH": "Switzerland",
    }

    const TITLES = {
        "0": "Herr",
        "1": "Frau",
        "2": "Familie"
    }

    export default {
        props: {
            handleSubmit: {
                type: Function,
                required: true
            },
            values: {
                type: Object,
                required: true
            },
            errors: {
                type: Object
            },
            initialValues: {
                type: Object
            }
        },
        computed: {
            item: function () {

                let values=this.initialValues ? this.initialValues : this.values;
                let newtranslations={};
                let translations = values.translations;
                Object.keys(API_LANGUAGES).map(function(objectKey, index) {
                    let value = API_LANGUAGES[objectKey];
                    let translation={
                        "@id":null,
                        associationRegister:"",
                        chamberOfCommerce:"",
                        commercialCourt:"",
                        commercialRegister:"",
                        cooperativesRegister:"",
                        description:"",
                        name:"",
                        legalName:"",
                        locale:objectKey,
                        partnershipRegister:"",
                        regulatoryAuthority:"",
                        additionalImageSources:""
                    }
                    if (values.translations) {

                        for (let index in translations) {
                            let val = translations[index];
                            if (val.locale===objectKey){
                                translation=val;
                            }
                        }
                    }
                    newtranslations[objectKey]=translation;

                });
                values.translations=newtranslations;
                return values;
            },
            translations: function () {
                let newtranslations={};
                let values = this.initialValues ? this.initialValues : this.values;
                if (values.translations){
                    let translations=values.translations;
                    for(let index in translations) {
                        let val = translations[index];
                        newtranslations[val.locale] = val;
                    }
                }
                return newtranslations;
            }
        },
        methods: {
            onLogoChange (image) {
                console.log(image);
                if (image) {
                    this.image = this.$refs.pictureInput.file;
                    const body = new FormData();
                    body.append('image', this.image, this.image.name);

                    return fetch(API_URL+'images/upload/organization', {
                        body,
                        method: 'POST',
                        //headers: { 'Content-Type': 'multipart/form-data' }
                    })
                        .then(response => response.json()).then(response => {
                            if (response.success===true){
                                console.log(this.item);
                                this.item.logo=response.images[0];
                            }
                        });
                } else {
                    console.log('FileReader API not supported: use the <form>, Luke!')
                }
            },
            dataURItoBlob(dataURI) {
                // convert base64/URLEncoded data component to raw binary data held in a string
                var byteString;
                if (dataURI.split(',')[0].indexOf('base64') >= 0)
                    byteString = atob(dataURI.split(',')[1]);
                else
                    byteString = unescape(dataURI.split(',')[1]);

                // separate out the mime component
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

                // write the bytes of the string to a typed array
                var ia = new Uint8Array(byteString.length);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                return new Blob([ia], {type:mimeString});
            },
            /*onCountryChange(sel){

                let addressCountry=this.item.addressCountry;
                $('#_addressCountry option').each(function(){
                    if (this.value===addressCountry){
                        $('.choice-'+this.value).show();
                    }else{
                        $('.choice-'+this.value).hide();
                    }
                });
            },*/
            doImportToggle(){
                if(this.item.doImport){
                    var doimport= confirm(' Import data from eHotelier now?');
                    if (doimport) {
                        let subdomain=this.item.multiclient ? this.item.multiclient : 'admin';
                        let fields = {
                            "idtext": null,
                            "name":null,
                            "email": null,
                            "emailPec": null,
                            "www": null,
                            "telintlareacode": null,
                            "tel": null,
                            "fax": null,
                            "logo": null,
                            "zip": null,
                            "vatnumber": null,
                            "additionalimagesources": null,
                            "settings": {"imprint": "null"}
                        }
                        fetch('https://' + subdomain + '.ehotelier.it/bnlocalproxy.php?path=services/hoteldata/de&portal_id=0&hotel_ids=' + this.item.ehotelierTextId + '&fields=' + JSON.stringify(fields) + '&clearcache=true', {method: 'GET'})
                            .then(response => response.json()).then(response => {
                            if (response.records[0]) {
                                let data = response.records[0];

                                if (data.idtext === this.item.ehotelierTextId) {
                                    console.log(data);
                                    this.item.email = data.email;
                                    this.item.url = data.www.substring(0,4)==='http' ? data.www : 'http://'+data.www;
                                    this.item.telephone = data.telintlareacode ? data.telintlareacode + ' ' + data.tel : data.tel;
                                    this.item.faxNumber = data.telintlareacode ? data.telintlareacode + ' ' + data.fax : data.fax;
                                    this.item.rea = data.settings.imprint.rea;
                                    this.item.uid = data.settings.imprint.uid;
                                    this.item.chamberOfCommerceNumber = data.settings.imprint.chamberofcommercenumber;
                                    this.item.commercialRegisterNumber = data.settings.imprint.commercialregisternumber;
                                    this.item.associationRegisterNumber = data.settings.imprint.associationregisternumber;
                                    this.item.partnershipsRegisterNumber = data.settings.imprint.partnershipsregisternumber;
                                    this.item.cooperativesRegisterNumber = data.settings.imprint.cooperativesregisternumber;
                                    this.item.commercialCourtNumber = data.settings.imprint.commercialcourtnumber;
                                    this.item.legalRepresentative = data.settings.imprint.legalrepresentative;
                                    this.item.administrator = data.settings.imprint.administrator;
                                    this.item.management = data.settings.imprint.management;
                                    this.item.taxID = data.settings.imprint.taxnumber;
                                    this.item.cir = data.settings.imprint.cir;
                                    this.item.cin = data.settings.imprint.cin;
                                    this.item.vatID = data.vatnumber;
                                    this.item.shareHolder = data.settings.imprint.shareholder;
                                    this.item.shareCapital = data.settings.imprint.sharecapital;
                                    this.item.editorial = data.settings.imprint.editorial;
                                    this.item.dataProtectionSupervisorTitle = ('undefined' !== typeof TITLES[data.settings.imprint.dataprotectionsupervisortitle]) ? TITLES[data.settings.imprint.dataprotectionsupervisortitle] : data.settings.imprint.dataprotectionsupervisortitle;
                                    this.item.dataProtectionSupervisor = data.settings.imprint.dataprotectionsupervisor;
                                    let ehotcountry = data.settings.imprint.country;
                                    for (let index in COUNTRIES) {
                                        if (COUNTRIES[index].toLowerCase() === ehotcountry) {
                                            this.item.addressCountry = index;
                                        }
                                    }


                                    this.item.addressRegion = '';
                                    this.item.postOfficeBoxNumber = '';
                                    this.item.postalCode = data.zip;

                                    this.item.translations['de'].additionalImageSources = data.additionalimagesources;

                                        console.log(this.item.translations);
                                    for (let index in this.item.translations) {
                                        let lang = this.item.translations[index].locale;
                                        if (data.settings.imprint['$translations'][lang]) {
                                            let transdata = data.settings.imprint['$translations'][lang];
                                            this.item.translations[index].name = data.name;
                                            this.item.translations[index].legalName = transdata.companyname;
                                            this.item.translations[index].chamberOfCommerce = transdata.chamberofcommerce;
                                            this.item.translations[index].commercialRegister = transdata.commercialregister;
                                            this.item.translations[index].associationRegister = transdata.associationregister;
                                            this.item.translations[index].partnershipRegister = transdata.partnershipsregister;
                                            this.item.translations[index].cooperativesRegister = transdata.cooperativesregister;
                                            this.item.translations[index].commercialCourt = transdata.commercialcourt;
                                            this.item.translations[index].regulatoryAuthority = transdata.regulatoryauthority;
                                            this.item.translations[index].description = transdata.additionalinfo;
                                            this.item.translations[index].addressLocality = transdata.taxlocation;
                                            this.item.translations[index].streetAddress = transdata.taxaddress;

                                            console.log(lang);



                                            fetch('https://' + subdomain + '.ehotelier.it/bnlocalproxy.php?path=services/hoteldata/'+lang+'&portal_id=0&hotel_ids=' + this.item.ehotelierTextId + '&fields=' + JSON.stringify({'name':null,'locale':null,'additionalimagesources':null}) + '&clearcache=true', {method: 'GET'})
                                                .then(response => { console.log(this); return response.json()}).then(response => {
                                                    console.log(response);
                                                    if (response.records[0]) {
                                                        let data = response.records[0];
                                                        this.item.translations[index].name = data.name;
                                                        this.item.translations[index].additionalImageSources = data.additionalimagesources;
                                                    }
                                            });



                                        }
                                    }
                                    console.log('https://' + subdomain + '.ehotelier.it/thumbnails/normal/1000x1000/hotel/'+data.logo+'.jpeg');
                                    //this.$refs.pictureInput.prefill='https://admin.ehotelier.it/thumbnails/normal/1000x1000/hotel/'+data.logo+'.jpeg';
                                    //this.item.logo='https://admin.ehotelier.it/thumbnails/normal/1000x1000/hotel/'+data.logo+'.jpeg';
                                    let newlogo=new Image();
                                    newlogo.setAttribute('crossOrigin', 'anonymous');
                                    let me=this;


                                    newlogo.onload=function(evt){
                                        let canvas = document.createElement("canvas");
                                        canvas.width = newlogo.width;
                                        canvas.height = newlogo.height;

                                        // Copy the image contents to the canvas
                                        let ctx = canvas.getContext("2d");
                                        ctx.drawImage(newlogo, 0, 0);

                                        // Get the data-URL formatted image
                                        // Firefox supports PNG and JPEG. You could check img.src to
                                        // guess the original format, but be aware the using "image/jpg"
                                        // will re-encode the image.
                                        let dataURL = canvas.toDataURL("image/png");


                                        //dataURL= dataURL.substr(dataURL.indexOf(",") + 1, dataURL.length)


                                        console.log(evt,me);
                                        let image=this;
                                        if (image) {
                                            me.image = me.$refs.pictureInput.file;
                                            const body = new FormData();
                                            body.append('image',  me.dataURItoBlob(dataURL), 'image');

                                            return fetch(API_URL+'images/upload/organization', {
                                                body,
                                                method: 'POST',
                                                //headers: { 'Content-Type': 'multipart/form-data' }
                                            })
                                                .then(response => response.json()).then(response => {
                                                    if (response.success===true){
                                                        console.log(me.item);
                                                        me.item.logo=response.images[0];
                                                    }
                                                });
                                        }
                                    }
                                    newlogo.src='https://' + subdomain + '.ehotelier.it/thumbnails/normal/1000x1000/hotel/'+data.logo+'.jpeg';





                                }

                            }
                        });
                    }
                }

            }
        },
        components: {
            PictureInput,
            VueEditor
        },
        data: function () {


            return {
                languages: API_LANGUAGES,
                api_url: API_URL,
                countries: COUNTRIES,
                descriptionToolbar: [
                    ['bold', 'italic', 'underline'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }]
                ],
                descriptionOptions: {
                    formats: [
                        'bold','underline','italic','list'
                    ]
                },
                additionalImageSourcesToolbar: [
                    ['bold', 'italic', 'underline'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }]
                ],
                additionalImageSourcesOptions: {
                    formats: [
                        'bold','underline','italic','list'
                    ]
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/organization/Form.vue